"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HowToUseModal;
var _ModalState = _interopRequireDefault(require("../../../state-observables/modal/ModalState"));
var _SimpleButton = _interopRequireDefault(require("../../SimpleButton"));
var _rc = _interopRequireDefault(require("../../../assets/how-to-use-modal/rc-1.png"));
var _rc2 = _interopRequireDefault(require("../../../assets/how-to-use-modal/rc-2.png"));
var _rc3 = _interopRequireDefault(require("../../../assets/how-to-use-modal/rc-3.png"));
var _rc4 = _interopRequireDefault(require("../../../assets/how-to-use-modal/rc-4.png"));
var _rc5 = _interopRequireDefault(require("../../../assets/how-to-use-modal/rc-5.png"));
require("./styles.css");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function HowToUseModal() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "how-to-use-modal-container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "how-to-use-modal-text-title",
      children: "What will I see in the Controller?"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _rc.default,
      alt: "sequencer-image",
      className: "how-to-use-modal-img"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "how-to-use-modal-text-paragraph",
      children: "This is what you will see in the Marty controller. The 7 buttons in the bottom right are all commands Marty can do while staying in one place. The arrows on the left make Marty walk and slide, tapping the green arrow will make Marty take one step forward; yellow arrow, one step backwards; blue arrow, slide once to the left; purple, slide once to the right. The color of border of the arrows are the same as our Marty Unplugged color cards, for example the green color card makes Marty walk forward in unplugged mode."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _rc2.default,
      alt: "sequencer-image",
      className: "how-to-use-modal-img"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "how-to-use-modal-text-paragraph",
      children: "The dot in the middle is the Marty Joystick. Dragging the dot forward or backwards will make Marty walk forwards or backwards and the more you move the dot from the centre, the longer Marty's steps will be. Unless dragged forward or back, the Joystick will make Marty turn to the left or right, in varying degrees."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _rc3.default,
      alt: "sequencer-image",
      className: "how-to-use-modal-img"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "how-to-use-modal-text-paragraph",
      children: "You can also control how fast Marty will move when using the directional arrows or the Joystick by changing the speed slider. Moving the slider to the right will make Marty move much more quickly, whereas moving the arrow to the left will make Marty much slower."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "how-to-use-modal-text-title",
      children: "The Sequencer"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "how-to-use-modal-text-paragraph",
      children: "You can enter the sequencer mode by pressing the toggle on the left of the screen. When you enter sequencer mode you will see dots appear on the race track and the joystick disappear."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _rc4.default,
      alt: "sequencer-image",
      className: "how-to-use-modal-img"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "how-to-use-modal-text-paragraph",
      children: "The sequencer in the controller allows you to sequence up to 15 commands that Marty will perform when you press play. To build a sequence all you need to do is select the movements you want Marty to perform and press the green flag to start, is it important to note that you can change the speed of each individual movement. Marty will run through the sequence and automatically stop when Marty gets to the end. If you want to stop Marty during the sequence you can do this by pressing the stop button which replaces the green flag during the sequence. Once Marty has ran through your sequence you can either get Marty to do it again or you can build a new sequence by pressing clear."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _rc5.default,
      alt: "sequencer-image",
      className: "how-to-use-modal-img"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SimpleButton.default, {
      onClick: () => _ModalState.default.closeModal(),
      title: "Close"
    })]
  });
}